/** packages/main-app/src/components/demos/AdvancedKey/hooks/useAdvancedKeyState.ts */

import { useState } from "react";
import { HigherKeyMode } from "@eweadn-qiankun/shared-types";
import type {
  DKSState,
  MPTState,
  MTState,
  TGLState,
  ENDState,
  SOCDState,
  RSState,
} from "./types";

export const useAdvancedKeyState = () => {
  const [selectedMode, setSelectedMode] = useState<HigherKeyMode>(
    HigherKeyMode.NONE
  );

  const [dksState, setDksState] = useState<DKSState>({
    kcs: [0, 0, 0, 0],
    trps: [127, 120, 120, 120],
    dbs: [1.5, 3],
  });

  const [mptState, setMptState] = useState<MPTState>({
    kcs: [0, 0, 0],
    dbs: [0.5, 1.0, 1.5],
  });

  const [mtState, setMtState] = useState<MTState>({
    kcs: [0, 0],
    time: 200,
  });

  const [tglState, setTglState] = useState<TGLState>({
    kcs: 0,
    delay: 0,
  });

  const [endState, setEndState] = useState<ENDState>({
    kcs: [0, 0],
    delay: 200,
  });

  const [socdState, setSocdState] = useState<SOCDState>({
    mode: 0,
    kcs: [0, 0],
    delay: 0,
  });

  const [rsState, setRsState] = useState<RSState>({
    kcs: [0, 0],
    delay: 0,
  });

  const handleModeChange = (mode: HigherKeyMode) => {
    setSelectedMode(mode);
  };

  return {
    selectedMode,
    dksState,
    mptState,
    mtState,
    tglState,
    endState,
    socdState,
    rsState,
    setDksState,
    setMptState,
    setMtState,
    setTglState,
    setEndState,
    setSocdState,
    setRsState,
    handleModeChange,
    getElementXyData,
  };
};

export const getElementXyData = (e: any) => {
  // 获取被点击的元素
  const targetEl = e.currentTarget || e.target;
  // 获取元素在页面中的位置
  const rect = targetEl.getBoundingClientRect();
  // X 取元素水平中心，Y 取顶部（用于气泡定位在正上方）
  const elementX = rect.left + rect.width / 2;
  const elementY = rect.top;
  return {
    x: elementX,
    y: elementY,
  };
};
